import { useEffect, useState } from 'react';

// The current time, re-read on each minute boundary (not every 60 s from
// mount), so a clock turns over with the wall clock. A tab that comes back to
// the foreground re-reads at once: browsers throttle timers in hidden tabs.
export function useMinuteTick(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    const schedule = () => {
      // A timer that fires a hair early re-reads the same minute and waits
      // the remaining milliseconds, so the clock never lags a whole minute.
      timer = setTimeout(() => { setNow(new Date()); schedule(); }, 60_000 - (Date.now() % 60_000));
    };
    const onVisible = () => {
      if (document.visibilityState !== 'visible') return;
      clearTimeout(timer);
      setNow(new Date());
      schedule();
    };
    schedule();
    document.addEventListener('visibilitychange', onVisible);
    return () => { clearTimeout(timer); document.removeEventListener('visibilitychange', onVisible); };
  }, []);
  return now;
}
